var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts),function(alert){return _c('div',[(alert.text)?_c('v-alert',{attrs:{"type":alert.type,"dismissible":""}},[_vm._v(" "+_vm._s(alert.text)+" ")]):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }